export default __webpack_public_path__ + "static/media/idd6.bcab15d1.png";